// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2773":"74383e2f","4029":"8df6908b","5771":"1083f5ad","7317":"2001f732","7727":"c9db91ee"}[chunkId] + ".chunk.css";
};